"use client";

import { cn } from "@scott/ui/utils/cn";
import { Hamburger, Logo } from "@ui-d2c/components/ui";
import type {
  BrandConfig,
  Category,
  NavItem,
  SubCategory,
} from "@ui-d2c/types";
import { AnimatedSearchField } from "./animated-search-field";
import { useNavigationStore } from "./use-navigation-store";

interface TopNavigationProps {
  brand: BrandConfig;
  navItems: NavItem[];
  onPanelChange: (
    _panel: string,
    _data: NavItem | Category | SubCategory
  ) => void;
  onHamburgerClick: () => void;
}

const TopNavigation: React.FC<TopNavigationProps> = ({
  brand,
  navItems,
  onPanelChange,
  onHamburgerClick,
}) => {
  const { setLevel, pushToDataLayer } = useNavigationStore();

  return (
    <nav
      className={`border-neutral-200 border-b font-nav-paragraph font-nav-weight text-black ${
        brand.value === "syncros" ? "bg-black" : "bg-white"
      }`}
    >
      <div className="container relative flex h-14 items-center justify-between px-4 lg:justify-start lg:px-8">
        <Hamburger
          aria-label="Toggle menu"
          className={"relative order-3 lg:order-1"}
          onClick={onHamburgerClick}
        />
        <div className="order-1 flex w-40 max-w-[190px] items-center justify-center lg:order-2 lg:mr-[50px] xl:w-48">
          <Logo brand={brand} url="/" variant="default" />
        </div>
        <ul
          className={`${brand.isDolomite ? "-translate-x-1/2 absolute left-1/2" : "order-3"} hidden space-x-4 lg:flex`}
        >
          {navItems.map((item, index) => {
            const content = (
              <span
                className={cn(
                  "cursor-pointer px-0 py-1 font-heading text-nav-customer-text text-sm uppercase hover:text-nav-customer-text-hover xl:px-1 xl:text-base 2xl:px-2",
                  item.onSale === "true"
                    ? "text-sale hover:text-sale-hover"
                    : "nosale"
                )}
              >
                {item.title}
              </span>
            );

            return (
              <li key={item.title}>
                {item.componentData?.link?.url &&
                !item.componentData?.navigationNode.children ? (
                  <a
                    href={item.componentData.link.url}
                    onClick={() => {
                      setLevel(1, item.titleEN, index);
                      pushToDataLayer();
                    }}
                  >
                    {content}
                  </a>
                ) : (
                  <div
                    onClick={() => {
                      setLevel(1, item.titleEN, index);
                      onPanelChange("second", item);
                    }}
                  >
                    {content}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        <AnimatedSearchField />
      </div>
    </nav>
  );
};

export { TopNavigation };
